import Loader from 'reusable/mobx-helpers/Loader'
import { makeAutoObservable } from 'mobx'
import { apiClient } from 'api/trpc/trpc-client'
import { FormHandlerConfig, formHandler } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import { snackbarError, snackbarSuccess } from 'reusable/mui/snackbar/snackbar'
import { CreateClientContactModalParams } from './CreateClientContactModal'
import CreateClientContactAutocompleteStore from './CreateClientContactAutocompleteStore'
import { AdvisorClientContactDto } from "@gap/backend/app-services/advisor/client/contact/models/AdvisorClientContactDto"

export default class CreateClientContactModalStore {
   loader = new Loader(false)
   fields = {
      firstName: '',
      lastName: '',
      email: ''
   }
   sp

   constructor(sp: CreateClientContactModalParams & { createClientContactAutocompleteStore: CreateClientContactAutocompleteStore }) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get formHandler() {
      return formHandler(this.fields, {
         firstName: { type: 'string', },
         lastName: { type: 'string' },
         email: { type: 'string' }
      } satisfies FormHandlerConfig)
   }

   createClientContact = async () => {
      this.loader.executeLoading(async () => {
         const { firstName, lastName, email } = this.fields

         if (this.sp.createClientContactAutocompleteStore.clientUsers.find(user => user.id === email)) {
            return snackbarError('A contact for this client already exists with the provided email address. Please try again with a different email address or use the existing contact for this client.')
         }

         if (this.formHandler.validate(AdvisorClientContactDto.createSchema)) {
            const advisorClientContact = await apiClient.advisor.createClientContact.mutate({
               clientId: this.sp.advisorClientId,
               email,
               firstName,
               lastName,
            })

            this.sp.createClientContactAutocompleteStore.fields.userIds.push(advisorClientContact.id)
            this.sp.createClientContactAutocompleteStore.clientUsers.push({
               id: advisorClientContact.id,
               label: `${advisorClientContact.name} (${advisorClientContact.email})`
            })

            snackbarSuccess('Contact created')
            this.sp.createClientContactAutocompleteStore.onNewContactCreated(advisorClientContact)
         }
      })
   }
}

